import { AxiosPromise } from 'axios';
import { csttFacadeApi } from '../csttFacadeApi';

const usersStatistics = () : AxiosPromise<ProfileInformationType> => csttFacadeApi.get('/csttfacade/user/v1/overview')
const usersSearch = (query: string): AxiosPromise<ProfileInformationType> => csttFacadeApi.get(`/csttfacade/user/v1/search?query=${query}`);
const usersData = (): AxiosPromise<Array<ProfileInformationType>> => csttFacadeApi.get('/csttfacade/user/v1/alldata');

export { usersSearch, usersData, usersStatistics }